import { render } from "./SurveyStep.vue?vue&type=template&id=577c6010&ts=true"
import script from "./SurveyStep.vue?vue&type=script&lang=ts"
export * from "./SurveyStep.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__